export { MultipleSelectorDeprecated } from './MultipleSelector';
export type { MultipleSelectorProps, DropdownItem } from './model';
